import * as paymentPopupActions from './actions';
import * as menuDebtsActions from '../menu/credit/debtDetail/actions';
import {Record} from '../transit';
import {Map} from 'immutable';
import {countDiscountPriceWithoutRound, betterRound} from '../lib/util';

const InitialState = Record({
    paymentPopupVisible: false,
    discountPrice: 0,
    price: 0,
    moneyGiven: 0,
    discount: 0,
    discountCurrency: 0,
    discountRadio: 'discount',
    paymentRadio: 'moneyGiven',
    defaultPaymentRadio: 'moneyGiven',
    touchKeyboard: false,
    lastKeyTime: null,
    paymentRadioTypes: {
        DISCOUNT: 'discount',
        DISCOUNT_CURRENCY: 'discountCurrency',
        MONEY_GIVEN: 'moneyGiven',
        SOME_ITEM: 'someItem'
    },
    items: Map(),
    selectedItemId: null
}, 'paymentPopup');
const initialState = new InitialState;

const PAYMENT_POPUP_VISIBLE = 'paymentPopupVisible';
const MONEY_GIVEN = 'moneyGiven';
const TOUCH_KEYBOARD = 'touchKeyboard';
const DISCOUNT_CURRENCY = 'discountCurrency';
const SOME_ITEM = 'someItem';
const DISCOUNT = 'discount';
const DISCOUNT_RADIO = 'discountRadio';
const PAYMENT_RADIO = 'paymentRadio';
const DEFAULT_PAYMENT_RADIO = 'defaultPaymentRadio';
const LAST_KEY_TIME = 'lastKeyTime';
const SELECTED_ITEM_ID = 'selectedItemId';
const ITEMS = 'items';
const DISCOUNT_PRICE = 'discountPrice';
const PRICE = 'price';

export default function categoriesReducer(state = initialState, action) {
    if (!(state instanceof InitialState)) {
        return initialState.mergeDeep(state);
    }

    switch (action.type) {

        case paymentPopupActions.SET_PAYMENT_ITEMS_WITH_ZERO_DISCOUNT: {
            const {items, price} = action.payload;

            return state
                .set(DISCOUNT_PRICE, price.toFixed(2))
                .set(SELECTED_ITEM_ID, null)
                .set(PRICE, price.toFixed(2))
                .set(ITEMS, items);
        }

        case paymentPopupActions.SET_DEFAULT_PAYMENT_RADIO: {
            return state
                .set(SELECTED_ITEM_ID, null)
                .set(ITEMS, Map())
                .set(DEFAULT_PAYMENT_RADIO, action.payload);
        }

        case paymentPopupActions.PAYMENT_CHANGE_RADIO: {
            const {type, itemId} = action.payload;
            return state
                .set(LAST_KEY_TIME, null)
                .set(SELECTED_ITEM_ID, typeof itemId === 'undefined' ? null : itemId)
                .set(PAYMENT_RADIO, type);
        }

        case paymentPopupActions.DISCOUNT_CHANGE_RADIO: {
            const {type} = action.payload;
            return state.set(DISCOUNT_RADIO, type);
        }

        case menuDebtsActions.FETCH_HABITUE_BIlLS_TO_PAY_SUCCESS:
        case paymentPopupActions.OPEN_PAYMENT_POPUP: {
            return state
                .set(LAST_KEY_TIME, null)
                .set(DISCOUNT_RADIO, state.get(DEFAULT_PAYMENT_RADIO) === DISCOUNT_CURRENCY ? DISCOUNT_CURRENCY : DISCOUNT)
                .set(PAYMENT_RADIO, state.get(DEFAULT_PAYMENT_RADIO))
                .set(DISCOUNT_CURRENCY, 0)
                .set(PAYMENT_POPUP_VISIBLE, true);
        }

        case paymentPopupActions.CLOSE_PAYMENT_POPUP: {
            return state
                .set(ITEMS, Map())
                .set(DISCOUNT_PRICE, 0)
                .set(SELECTED_ITEM_ID, null)
                .set(DISCOUNT_CURRENCY, 0)
                .set(DISCOUNT, 0)
                .set(DISCOUNT_RADIO, state.get(DEFAULT_PAYMENT_RADIO) === DISCOUNT_CURRENCY ? DISCOUNT_CURRENCY : DISCOUNT)
                .set(PAYMENT_RADIO, state.get(DEFAULT_PAYMENT_RADIO))
                .set(MONEY_GIVEN, 0)
                .set(TOUCH_KEYBOARD, false)
                .set(PAYMENT_POPUP_VISIBLE, false);
        }

        case paymentPopupActions.CLEAR_DISCOUNT: {
            let newState = state.set(LAST_KEY_TIME, null)
                .set(TOUCH_KEYBOARD, false);

            if (newState.get(SELECTED_ITEM_ID) === null) {
                newState = newState
                    .update(ITEMS, items => items.map(item => item.set('discount', 0)))
                    .set(DISCOUNT, 0);
            } else {
                newState = newState.updateIn([ITEMS, newState.get(SELECTED_ITEM_ID)], item => item.set('discount', 0));
            }

            newState = newState.set(DISCOUNT_CURRENCY, 0);
            return countSumDiscountPrice(newState);
        }

        case paymentPopupActions.RESET_PAYMENT_MONEY: {
            return state
                .set(LAST_KEY_TIME, null)
                .set(TOUCH_KEYBOARD, false)
                .set(MONEY_GIVEN, action.payload);
        }

        case paymentPopupActions.MONEY_GIVEN_ADD: {
            const sum = action.payload;

            if ((state.get(MONEY_GIVEN) + sum) > 1000000) {
                return state.set(MONEY_GIVEN, 1000000);
            }

            return state
                .set(TOUCH_KEYBOARD, false)
                .set(LAST_KEY_TIME, new Date().getTime())
                .update(MONEY_GIVEN, money => lastKeyTimeout(state) ? sum : money + sum)
        }

        case paymentPopupActions.MONEY_GIVEN_CONNECT_TO_END: {
            const sum = action.payload;
            const type = state.get(PAYMENT_RADIO);

            let newSum = 0;
            let newState = state;
            if (!lastKeyTimeout(newState) && newState.get(TOUCH_KEYBOARD)) {
                let sumBeforeUpdate = 0;
                if (type === SOME_ITEM) {
                    sumBeforeUpdate = newState.getIn([ITEMS, newState.get(SELECTED_ITEM_ID), DISCOUNT]);
                } else {
                    sumBeforeUpdate = newState.get(type);
                }
                newSum = parseInt(`${sumBeforeUpdate}${sum}`);
            } else {
                newSum = parseInt(sum);
            }

            const max = type === MONEY_GIVEN
                ? 1000000
                : type === DISCOUNT_CURRENCY
                    ? newState.get(PRICE)
                    : 100;

            if (newSum >= max) {
                newSum = max;
            }

            if (type === DISCOUNT) {
                newState = newState.set(DISCOUNT, newSum);
                newState = newState.update(ITEMS, items => items.map(item => item.set(DISCOUNT, newState.get(DISCOUNT))));
            } else if (type === SOME_ITEM) {
                newState = newState.updateIn([ITEMS, newState.get(SELECTED_ITEM_ID)], item => item.set(DISCOUNT, newSum));
                newState = newState.set(DISCOUNT_CURRENCY, 0);
            } else if (type === DISCOUNT_CURRENCY) {
                if (newState.get(PRICE) <= 0) {
                    return state;
                }

                newState = newState.set(DISCOUNT_CURRENCY, newSum);

                const countedDiscount = (1 - ((newState.get(PRICE) - newSum) / newState.get(PRICE))) * 100;
                newState = newState.set(DISCOUNT, countedDiscount);
                newState = newState.update(ITEMS, items => items.map(item => item.set(DISCOUNT, countedDiscount)));
            } else {
                newState = newState.set(type, newSum);
            }

            newState = countSumDiscountPrice(newState);
            if (newSum >= max) {
                return newState;
            }

            return newState
                .set(LAST_KEY_TIME, new Date().getTime())
                .set(TOUCH_KEYBOARD, true);
        }

    }

    return state;
}

function countSumDiscountPrice(state) {
    const discountPrice = Number(state.get(ITEMS).reduce((sum, item) => sum + (countDiscountPriceWithoutRound(item.get('price') * item.get('pcs'), item.get(DISCOUNT))), 0)).toFixed(2);
    let newState = state.set(DISCOUNT_PRICE, discountPrice);
    if (state.get(PAYMENT_RADIO) === SOME_ITEM) {
        const discount = (1 - (discountPrice / newState.get(PRICE))) * 100;
        newState = newState.set(DISCOUNT, betterRound(discount, 2));
    }
    return newState;
}

function lastKeyTimeout(state) {
    const lastKeyTime = state.get(LAST_KEY_TIME);
    return lastKeyTime === null || ((lastKeyTime + 1500) < new Date().getTime())
}



// WEBPACK FOOTER //
// ./src/common/paymentPopup/reducer.js